import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiMenuAlt3, HiX } from 'react-icons/hi';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Methodology', href: '#methodology' },
    { name: 'Insights', href: '#insights' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'header-glass py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container-main flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          data-testid="header-logo"
          className="text-2xl font-light tracking-[0.15em] text-[#0A192F]"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          SUSANA
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => scrollToSection(link.href)}
              data-testid={`nav-link-${link.name.toLowerCase()}`}
              className="text-sm font-medium text-[#0A192F]/70 hover:text-[#0A192F] transition-colors link-hover"
            >
              {link.name}
            </button>
          ))}
        </nav>

        {/* Desktop CTA */}
        <a
          href="#contact"
          data-testid="header-cta"
          className="hidden md:inline-flex btn-primary text-sm py-3 px-6"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('#contact');
          }}
        >
          Book a Call
        </a>

        {/* Mobile Menu Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#0A192F] p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <HiX size={24} /> : <HiMenuAlt3 size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#FDFBF7] border-t border-[#0A192F]/10"
            data-testid="mobile-menu"
          >
            <nav className="container-main py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                  className="text-lg font-medium text-[#0A192F]/70 hover:text-[#0A192F] transition-colors text-left"
                >
                  {link.name}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('#contact')}
                data-testid="mobile-cta"
                className="btn-primary mt-4 text-center"
              >
                Book a Call
              </button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
